import './funda-ratings.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function initFundaRatings() {
	const roots = document.querySelectorAll( '[data-component="funda-ratings"]' );

	if ( ! roots.length ) {
		return;
	}

	roots.forEach( ( root ) => {
		const triggers = [];

		const rings = root.querySelectorAll( '.b-fundaRatings__ringProgress' );
		rings.forEach( ( ring ) => {
			const radius = parseFloat( ring.getAttribute( 'r' ) );
			const circumference = 2 * Math.PI * radius;
			const card = ring.closest( '.b-fundaRatings__card' );
			const valueEl = card ? card.querySelector( '.b-fundaRatings__value' ) : null;
			const targetValue = valueEl ? parseFloat( valueEl.dataset.score ) : 10;
			const offset = circumference - ( targetValue / 10 ) * circumference;

			gsap.set( ring, { strokeDasharray: circumference, strokeDashoffset: circumference } );

			const ringTrigger = ScrollTrigger.create( {
				trigger: root,
				start: 'top 70%',
				animation: gsap.to( ring, {
					strokeDashoffset: offset,
					duration: 1.5,
					ease: 'power2.out',
				} ),
			} );
			triggers.push( ringTrigger );
		} );

		const scores = root.querySelectorAll( '.b-fundaRatings__value' );
		scores.forEach( ( score ) => {
			const targetValue = parseFloat( score.dataset.score );
			score.textContent = '0.0';
			const counter = { val: 0 };

			const counterTrigger = ScrollTrigger.create( {
				trigger: root,
				start: 'top 70%',
				animation: gsap.to( counter, {
					val: targetValue,
					duration: 1.5,
					ease: 'power2.out',
					onUpdate: () => {
						score.textContent = counter.val.toFixed( 1 );
					},
				} ),
			} );
			triggers.push( counterTrigger );
		} );

		root._fundaRatingsCleanup = () => {
			triggers.forEach( ( st ) => st.kill() );
		};
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initFundaRatings );
} else {
	initFundaRatings();
}
